// MultipartForm
// ====

import './app';
import MultipartForm from './Components/MultipartForm';

console.log(window);
window.MultipartForm = MultipartForm;
